import { render, staticRenderFns } from "./globalConfig.vue?vue&type=template&id=1fa0dcb0&"
import script from "./globalConfig.vue?vue&type=script&lang=js&"
export * from "./globalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports